import { WorldConfig } from '../../../src/feature/world/world.model';

export const worldConfig: WorldConfig = {
  startingPOI: 'from-north-to-beggen-1',
  startingMap: '0-0',
  maps: [{ id: '0-0', imagePath: '0-0.webp', size: [2500, 2500] }],
  // mode: 'map-builder',
};
